import { BillPayType } from './billpay.type';


//billpay details


export const setMoneyTransferTotalAmount2 = (data) => ({
    type: BillPayType.setMoneyTransferTotalAmount2,
    payload: data
    
  });
  export const setMoneyTransferSurChargeAmount2 = (data) => ({
    type: BillPayType.setMoneyTransferSurChargeAmount2,
    payload: data
    
  });
  export const showCreateOrderResponse2 = (data) => ({
    type: BillPayType.showCreateOrderResponse2,
    payload: data
    
  });
  export const setOrderId2 = (data) => ({
    type: BillPayType.setOrderId2,
    payload: data
    
  });
  export const setAmount2 = (data) => ({
    type: BillPayType.setAmount2,
    payload: data
    
  });

  export const setBillPayOperator = (data) => ({
    type: BillPayType.setBillPayOperator,
    payload: data
    
  });

  export const setSelectedBillerCategoryCode= (data) => ({
    type: BillPayType.setSelectedBillerCategoryCode,
    payload: data
    
  });
  export const setBillPayMobile = (data) => ({
    type: BillPayType.setBillPayMobile,
    payload: data
    
  });
  export const setBillPayOptional = (data) => ({
    type: BillPayType.setBillPayOptional,
    payload: data
    
  });

export const selectedRechargableAmnt2 = (data) => ({
    type: BillPayType.selectedRechargableAmnt2,
    payload: data
    
  });


export const setTxnAmount2 = (data) => ({
  type: BillPayType.setTxnAmount2,
  payload: data
  
});

export const setTxnsurcharge2 = (data) => ({
  type: BillPayType.setTxnsurcharge2,
  payload: data
  
});

export const setTxntotalAmount2 = (data) => ({
  type: BillPayType.setTxntotalAmoun2,
  payload: data
  
});

  
export const setMoneyTransferProgress2 = (data) => ({
  type: BillPayType.setMoneyTransferProgress2,
  payload: data
  
});

export const setCreteOrderReq2= (data) => ({
  type: BillPayType.setCreteOrderReq2,
  payload: data
  
});

export const setCreateOrderRes2= (data) => ({
  type: BillPayType.setCreateOrderRes2,
  payload: data
  
});
export const setStatusEnqResponse2= (data) => ({
  type: BillPayType.setStatusEnqResponse2,
  payload: data
  
});


export const setBillPayTxnHistory= (data) => ({
  type: BillPayType.setBillPayTxnHistory,
  payload: data
  
});

export const setFilterStartDate = (data) => ({
  type: BillPayType.setFilterStartDate,
  payload: data
  
});
export const setFilterEndDate = (data) => ({
  type: BillPayType.setFilterEndDate,
  payload: data
  
});

export const setCurrentBillerName = (data) => ({
  type: BillPayType.setCurrentBillerName,
  payload: data
  
});

export const setBillFetchAllParam = (data) => ({
  type: BillPayType.setBillFetchAllParam,
  payload: data
  
});



  export const resetBillPayData ={
    type: BillPayType.RESET
  }

